import React, { useState, useContext } from "react"; // Add useContext
import { StatutoryWarningContext } from "../context/StatutoryWarningContext";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./StatutoryWarningAdd.css"; // Renamed CSS
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";

function StatutoryWarningAdd() {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [uploading, setUploading] = useState(false);
    const { addWarningToState } = useContext(StatutoryWarningContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUploading(true);
        try {
            const docRef = await addDoc(collection(db, "statutory-warnings"), {
                title,
                content,
                imageUrl,
                date: serverTimestamp()
            });

            const newWarning = {
                id: docRef.id,
                title,
                content,
                imageUrl,
                date: { seconds: Math.floor(Date.now() / 1000) } // Use a client-side date
            };

            addWarningToState(newWarning);
            setTitle("");
            setContent("");
            setImageUrl("");
            Swal.fire({
                icon: "success",
                title: "Statutory warning added successfully!", // Changed text
                showConfirmButton: false,
                timer: 1200
            }).then(() => navigate("/statutory-warning")); // Navigate to new section
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Failed to add statutory warning", // Changed text
                text: err.message
            });
        }
        setUploading(false);
    };

    return (
        <div className="statutory-warning-add-container"> {/* Renamed class */}
            <h2>Add New Statutory Warning</h2> {/* Changed text */}
            <form onSubmit={handleSubmit}>
                <input type="text" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} required />
                <div style={{ marginBottom: "40px" }}>
                    <ReactQuill
                        value={content}
                        onChange={setContent}
                        style={{ height: "200px", marginBottom: 16 }}
                    />
                </div>
                <div style={{ marginBottom: 12 }}>
                    <label>Image URL :  </label>
                    <input type="url" placeholder="https://example.com/image.jpg" value={imageUrl} onChange={e => setImageUrl(e.target.value)} />
                </div>
                <button type="submit" className="button" disabled={uploading}>{uploading ? "Adding..." : "Add Statutory Warning"}</button> {/* Changed text */}
            </form>
        </div>
    );
}

export default StatutoryWarningAdd;